import React from 'react';
import {UserCallActivity} from '@store/call-card/UserCallActivity';
import {List} from 'immutable';
import {formatDate} from 'utils/formatDate';
import {isTriggersUser} from 'records/User';
import TriggerUserAvatar from 'components/inbox/call-history/TriggerUserAvatar';
import {UserAvatar} from '@components/util/UserAvatar';
import getFullName from 'utils/getFullName';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import HistoryItemMarkers from 'components/inbox/call-history/HistoryItemMarkers';
import './ActivityTabContent.sass';

interface ActivityTabContentProps {
  activities: List<UserCallActivity>;
  callId: FileUploadId;
}

export const ActivityTabContent: React.FC<ActivityTabContentProps> = ({activities, callId}) => {
  if (activities.isEmpty()) {
    return <div className="empty-state">This call has no activity yet.</div>;
  }

  return (
    <table className="activity-tab-content generic-table">
      <thead>
        <tr>
          <th className="day">Last Activity Date</th>
          <th className="action-by">Action By</th>
          <th className="history-item-markers-cell">Actions</th>
        </tr>
      </thead>
      <tbody>
        {activities.map(({actionUser, lastActivityDate, items}) => (
          <tr key={actionUser.id}>
            <td className="day">{formatDate(lastActivityDate)}</td>
            <td className="action-by">
              {isTriggersUser(actionUser) ? (
                <>
                  <TriggerUserAvatar /> Coach
                </>
              ) : (
                <>
                  <UserAvatar user={actionUser} /> {getFullName(actionUser)}
                </>
              )}
            </td>
            <td className="history-item-markers-cell">
              <HistoryItemMarkers items={items} fileUploadId={callId} newCallCard />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
